export default {
  // 面包屑
  projectList: '项目列表',
  deviceList: '设备列表',

  // 按钮
  addButton: '新增',
  enterButton: '进入',
  detailButton: '详情',
  firmwareButton: '固件管理',
  deleteButton: '删除',

  // 表格列标题
  projectNameColumn: '项目名称',
  deviceNameColumn: '设备名称',
  deviceSnColumn: '设备SN',
  firmwareVersionColumn: '固件版本',
  statusColumn: '状态',
  actionColumn: '操作',
  videoStreamColumn: '视频流',

  // 状态
  online: '在线',
  offline: '离线',

  // 确认对话框
  deleteConfirmTitle: '确定删除吗？',
  confirmButton: '确定',
  cancelButton: '取消',

  // 加载提示
  loading: '正在努力加载...',

  // Tab标签
  airportTab: '机场',
  aircraftTab: '飞机',

  // 成功消息
  deleteSuccess: '删除成功',
}
